export type CourseDurationUnit = 'month' | 'week' | 'day'

const durationUnitLabels: Record<
  CourseDurationUnit,
  { singular: string; plural: string }
> = {
  month: { singular: 'месяца', plural: 'месяцев' },
  week: { singular: 'недели', plural: 'недель' },
  day: { singular: 'дня', plural: 'дней' },
}

export const formatCourseDuration = (
  value?: number | string | null,
  unit?: CourseDurationUnit | null,
): string | null => {
  if (value === null || value === undefined || value === '') return null

  const duration = Number(value)
  if (!Number.isFinite(duration) || duration <= 0) return null

  const normalizedUnit =
    unit && durationUnitLabels[unit] ? unit : 'month'
  const labels = durationUnitLabels[normalizedUnit]
  const isSingular = duration % 10 === 1 && duration % 100 !== 11

  return `от ${duration} ${isSingular ? labels.singular : labels.plural}`
}
